import { createAsyncThunk } from "@reduxjs/toolkit";
import { CommonRootState } from "@common/types/common-root-state-type";
import { DBWaNoteThunks } from "./DBServiceThunks";
import { subscriptionPopupActions } from "./SubscriptionPopupReducer";
import { WaNote } from "@common-models/WaNote";

interface CreateNoteParams {
    note: WaNote;
}

// Create new note with CRM limit error handling
export const createWaNoteThunk = createAsyncThunk<
    WaNote,
    CreateNoteParams,
    { state: CommonRootState }
>(
    'waNotes/createWithLimitCheck',
    async ({ note }, thunkApi) => {
        const dispatch = thunkApi.dispatch;

        // #1136: the create REJECTS with a typed DBCreateError when nothing was stored.
        const action = await dispatch(DBWaNoteThunks.create(note));
        if (DBWaNoteThunks.create.fulfilled.match(action)) {
            return action.payload;
        }

        const errorMessage = action.payload?.message ?? action.error.message ?? 'Failed to create note';
        console.error('[wa-notes-thunks] Server validation error:', action.payload ?? action.error);

        // Check if error is due to CRM limit reached
        if (errorMessage.includes('total notes limit') || errorMessage.includes('reached your total notes limit')) {
            dispatch(subscriptionPopupActions.openPopup({
                feature: 'notes',
                message: errorMessage,
                upgradeReason: 'total_notes_limit'
            }));
        } else if (errorMessage.includes('notes limit for this contact') || errorMessage.includes('per contact')) {
            dispatch(subscriptionPopupActions.openPopup({
                feature: 'notes',
                message: errorMessage,
                upgradeReason: 'per_contact_notes_limit'
            }));
        }
        throw new Error(errorMessage);
    }
);
